import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RaceSummary } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummary';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';

import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { HeaderMetaAntePost } from 'src/domains/sportsbook/webview/components/raceSummary/antePost/HeaderMeta';
import { HeaderMetaSpecials } from 'src/domains/sportsbook/webview/components/raceSummary/specials/HeaderMeta';

interface MeetingsRaceCardType {
    section: 'ante-post' | 'specials';
    markets: Array<MarketModel> | null;
}

export const MeetingsRaceCard = observer(
    'MeetingsRaceCard',
    ({ section, markets }: MeetingsRaceCardType): JSX.Element | null => {
        const common = useCommon();
        const starRouter = StarRouter.get(common);

        if (markets === null || markets.length === 0) {
            return null;
        }

        const getCloseEvent = (market: MarketModel, section: 'ante-post' | 'specials') => {
            return () => {
                const eventModel = market.getEvent();
                if (eventModel === null) {
                    return;
                }
                const sport = eventModel.sport;

                if (sport === 'horseracing') {
                    starRouter.redirectToRace('horseracing', section, null);
                }

                if (sport === 'greyhoundracing') {
                    starRouter.redirectToRace('greyhoundracing', section, null);
                }
            };
        };

        const isSpecialsSection = section === 'specials';
        const isAntePostSection = section === 'ante-post';

        const firstMarket = markets[0];
        if (firstMarket === undefined) {
            return null;
        }

        return (
            <div>
                {isAntePostSection && (
                    <HeaderMetaAntePost
                        marketId={firstMarket.id2}
                        closeEvent={getCloseEvent(firstMarket, section)}
                    />
                )}

                {isSpecialsSection && (
                    <HeaderMetaSpecials
                        marketId={firstMarket.id2}
                        closeEvent={getCloseEvent(firstMarket, section)}
                    />
                )}

                {markets.map((market: MarketModel) => (
                    <RaceSummary
                        key={market.id}
                        marketId={market.id2}
                        isAntePost={isAntePostSection}
                        isSpecials={isSpecialsSection}
                    />
                ))}
            </div>
        );
    }
);
